// extracted by mini-css-extract-plugin
module.exports = {"automotive-banner":"automotive-banner--d9i7q","automotive-banner--mobile":"automotive-banner--mobile--d9i7q"};